import { useSelector } from 'react-redux';
import { constants, getSpecificClientConfig } from 'redux/modules/client-config/selectors';

const useNonPalletizedType = (
  load,
  realPallets,
  loadTypes,
  palletText,
  defaultPallet,
  withEquivalents
) => {
  const isContainerLoad = useSelector((store) =>
    getSpecificClientConfig(store, constants.CONTAINER_LOAD)
  );

  const container = { ...load }.container_iso_code;
  const newloadTypes = Array.isArray(loadTypes) ? loadTypes : [loadTypes];
  let showSpecialEquivalents = withEquivalents && palletText !== defaultPallet;
  let numberOfPallets = realPallets;

  if (newloadTypes && newloadTypes?.length > 1) {
    showSpecialEquivalents = true;
    palletText = 'MIXED_PALLET';
  } else if (newloadTypes && newloadTypes?.indexOf('BULK') !== -1) {
    palletText = 'BULK';
  } else if (newloadTypes && newloadTypes?.indexOf('PARCEL') !== -1) {
    palletText = 'PARCEL';
  }

  if (
    isContainerLoad &&
    ((newloadTypes && newloadTypes?.indexOf('SHIPPING_CONTAINER') !== -1) || container)
  ) {
    palletText = container ? `- ${container}` : `- cont. code`;
    showSpecialEquivalents = false;
    numberOfPallets = 1;
  } else if (isContainerLoad) {
    palletText = '';
    showSpecialEquivalents = false;
    numberOfPallets = '';
  }

  return {
    palletText,
    showSpecialEquivalents,
    numberOfPallets,
  };
};

export default useNonPalletizedType;
